module.exports = __webpack_public_path__ + "img/scene1-img.59619621.png";